var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 834,
    viewBox: "0 0 430 834",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_10006_2855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.801 245.195C123.814 245.037 123.83 244.878 123.83 244.723C123.83 239.594 119.141 235.441 113.361 235.441C112.545 235.441 111.761 235.529 111.004 235.683C110.603 230.624 106.09 226.633 100.569 226.633C94.7828 226.633 90.0866 231.01 90.0866 236.409C90.0866 236.849 90.1333 237.284 90.1937 237.71C89.8826 237.683 89.5789 237.666 89.266 237.666C83.4802 237.666 78.7859 241.84 78.7859 246.989C78.7859 247.24 78.8106 247.481 78.8325 247.728C78.8179 247.728 78.8042 247.728 78.7859 247.728C74.0019 247.728 69.8464 249.451 69.5491 254.831C69.4384 256.883 70.1886 260.096 74.6039 261.883C77.0466 262.871 82.3539 262.584 96.3289 262.584C113.457 262.584 128.894 262.619 128.894 262.619C132.808 261.929 134.769 258.702 135.09 255.65C135.727 249.7 130.234 245.037 123.801 245.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.714 292.004C359.723 291.871 359.737 291.737 359.737 291.607C359.737 287.29 355.79 283.794 350.926 283.794C350.239 283.794 349.578 283.868 348.942 283.998C348.604 279.741 344.807 276.383 340.159 276.383C335.29 276.383 331.339 280.066 331.339 284.61C331.339 284.981 331.378 285.347 331.428 285.706C331.168 285.683 330.91 285.668 330.649 285.668C325.78 285.668 321.826 289.181 321.826 293.515C321.826 293.726 321.848 293.93 321.866 294.136C321.855 294.136 321.843 294.136 321.826 294.136C317.803 294.136 314.303 295.586 314.055 300.115C313.962 301.842 314.593 304.546 318.308 306.049C320.364 306.881 324.832 306.64 336.591 306.64C351.004 306.64 363.995 306.669 363.995 306.669C367.291 306.089 368.939 303.372 369.211 300.805C369.748 295.795 365.125 291.87 359.714 292.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.524 409.608C354.535 409.445 354.552 409.282 354.552 409.124C354.552 403.852 349.733 399.585 343.795 399.585C342.955 399.585 342.149 399.677 341.372 399.833C340.961 394.635 336.322 390.535 330.649 390.535C324.702 390.535 319.879 395.032 319.879 400.58C319.879 401.032 319.927 401.478 319.988 401.916C319.669 401.889 319.355 401.871 319.037 401.871C313.09 401.871 308.266 406.161 308.266 411.451C308.266 411.709 308.292 411.957 308.314 412.211C308.3 412.211 308.284 412.211 308.266 412.211C303.354 412.211 299.081 413.982 298.776 419.51C298.663 421.619 299.434 424.92 303.971 426.756C306.481 427.771 311.936 427.477 326.294 427.477C343.893 427.477 359.753 427.512 359.753 427.512C363.777 426.803 365.792 423.487 366.122 420.352C366.775 414.236 361.132 409.445 354.524 409.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.333 338.329C311.507 334.182 293.74 333.542 291.635 333.482C283.957 333.272 276.064 335.627 268.467 335.768C262.05 335.886 251.195 337.115 245.119 337.538C239.47 337.933 243.728 341.276 251.793 341.253C254.281 344.572 266.123 342.65 269.785 342.724C279.969 342.928 290.166 343.22 300.356 342.852C302.845 342.768 322.62 342.95 323.339 340.169C323.692 338.437 310.758 338.49 309.333 338.329C312.702 338.706 310.213 336.648 309.333 338.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.438 353.734C157.372 356.6 157.344 359.481 157.348 362.383C157.344 359.481 157.371 356.599 157.438 353.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.874 333.173C149.409 345.495 148.494 358.402 148.215 371.721L148.226 371.72C148.495 358.402 149.409 345.495 150.885 333.172L150.874 333.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.621 279.898C112.205 299.743 102.348 325.148 102.332 352.831L140.894 352.731C140.891 334.396 143.753 317.066 148.864 301.69C140.565 295.759 133.639 288.379 128.621 279.898Z",
    fill: "#C9281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.326 257.961C281.751 264.534 279.148 270.833 275.676 276.714C287.662 296.871 294.996 323.327 295.131 352.332L333.697 352.232C333.466 313.062 313.557 278.556 283.326 257.961Z",
    fill: "#C9281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.941 307.085C244.404 320.998 245.243 336.338 245.281 352.462L295.132 352.333C294.997 323.328 287.663 296.872 275.677 276.715C268.29 289.226 256.937 299.831 242.941 307.085Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.876 301.695C143.759 317.069 140.892 334.399 140.895 352.734L190.742 352.604C190.715 340.228 191.152 328.309 191.979 317.141C175.794 315.795 160.89 310.28 148.876 301.695Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.258 316.886C204.046 317.57 197.933 317.632 191.981 317.141C191.154 328.308 190.717 340.228 190.743 352.603L245.283 352.459C245.245 336.336 244.406 320.996 242.943 307.082C233.182 312.144 222.132 315.577 210.258 316.886Z",
    fill: "#C9281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.861 301.692C161.426 263.937 187.508 237.968 217.709 237.887C181.809 237.985 149.775 254.326 128.617 279.9C133.634 288.381 140.561 295.761 148.861 301.692Z",
    fill: "#E85B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.715 237.895C240.77 237.829 261.487 252.858 275.68 276.715C279.152 270.834 281.754 264.534 283.33 257.961C264.657 245.243 242.059 237.829 217.715 237.895Z",
    fill: "#E85B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.715 237.895C228.948 237.864 238.66 266.354 242.944 307.084C256.939 299.83 268.293 289.226 275.68 276.715C261.487 252.858 240.77 237.829 217.715 237.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.716 237.895C187.515 237.97 161.433 263.94 148.879 301.696C160.892 310.28 175.796 315.796 191.983 317.144C195.421 271.174 205.6 237.927 217.716 237.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.715 237.892C217.715 237.887 217.715 237.887 217.715 237.887C187.514 237.968 161.432 263.937 148.867 301.692L148.878 301.694C161.431 263.936 187.514 237.968 217.715 237.892Z",
    fill: "#CF0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.714 237.895C205.599 237.927 195.42 271.175 191.98 317.144C197.933 317.634 204.046 317.573 210.257 316.888C222.132 315.58 233.181 312.147 242.942 307.084C238.657 266.354 228.947 237.863 217.714 237.895Z",
    fill: "#E85B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.996 341.445C107.529 344.734 102.621 348.465 102.352 352.419C106.117 351.6 110.32 350.817 114.884 350.082C115.21 347.18 115.582 344.298 115.996 341.445Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.466 350.737C332.436 347.191 327.665 343.868 319.961 340.922C320.356 343.511 320.712 346.123 321.029 348.756C326.376 357.982 329.653 350.038 333.466 350.737Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.575 346.002C149.94 341.665 150.376 337.385 150.876 333.172C136.427 335.342 124.448 338.175 115.995 341.448C115.581 344.3 115.209 347.183 114.883 350.086C125.675 358.922 138.367 363.707 149.575 346.002Z",
    fill: "#931A0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.032 348.75C320.715 346.117 320.359 343.504 319.964 340.915C311.503 337.686 299.504 334.918 285.035 332.82C285.539 336.895 285.988 341.036 286.371 345.238C299.377 356.987 309.977 358.234 321.032 348.75Z",
    fill: "#931A0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.369 345.24C285.986 341.039 285.537 336.898 285.033 332.822C272.223 330.97 257.461 329.645 241.5 329.008C241.731 333.691 241.932 338.464 242.109 343.309C257.571 359.661 269.132 365.449 286.369 345.24Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.395 329.133C178.443 329.855 163.687 331.255 150.89 333.172C150.38 337.386 149.943 341.666 149.578 346.003C159.625 364.262 178.24 362.322 193.858 343.563C194.011 338.671 194.19 333.851 194.395 329.133Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.327 355.441C227.645 355.424 232.581 357.571 242.113 343.309C241.936 338.465 241.736 333.692 241.504 329.008C233.893 328.701 226.022 328.549 217.952 328.573C209.874 328.594 202.001 328.782 194.392 329.133C194.187 333.852 194.007 338.671 193.855 343.561C202.709 355.489 211.187 355.467 220.327 355.441Z",
    fill: "#931A0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.715 363.1C121.735 366.519 133.625 369.476 148.213 371.725C148.41 362.957 148.857 354.373 149.571 346.008C136.522 347.111 124.814 348.49 114.879 350.091C114.387 354.371 114.004 358.707 113.715 363.1Z",
    fill: "#C42211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.375 345.246C287.162 353.734 287.674 362.452 287.901 371.363C302.48 369.037 314.354 366.02 322.356 362.558C322.034 357.896 321.589 353.295 321.035 348.757C310.911 347.345 299.237 346.16 286.375 345.246Z",
    fill: "#C42211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.113 343.305C242.49 353.789 242.719 364.645 242.79 375.767C259.456 374.976 274.777 373.443 287.9 371.352C287.672 362.442 287.161 353.723 286.374 345.235C272.788 344.27 257.873 343.605 242.113 343.305Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.349 375.905C193.355 364.828 193.533 354.015 193.847 343.566C177.979 344.036 163.056 344.874 149.567 346.007C148.852 354.372 148.406 362.957 148.219 371.724C161.351 373.744 176.676 375.194 193.349 375.905Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.605 343.14C211.459 343.163 202.512 343.309 193.85 343.562C193.535 354.011 193.358 364.823 193.352 375.901C201.31 376.236 209.583 376.405 218.068 376.385C226.556 376.362 234.821 376.15 242.784 375.771C242.713 364.648 242.484 353.794 242.107 343.308C235.089 343.183 227.913 343.121 220.605 343.14Z",
    fill: "#C42211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.585 445.922L218.02 445.159L293.749 291.137L295.389 291.438L219.585 445.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.482 446.095L218.137 444.981L332.465 307.637L331.981 310.941L219.482 446.095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.672 445.678L217.945 445.395L244.344 286L246.176 286.087L219.672 445.678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.032 445.93L141.48 291.539L143.599 291.156L219.59 445.155L218.032 445.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.143 446.105L107 316.551L111.372 319.048L219.464 444.97L218.143 446.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.938 445.682L190.324 286.167L192.41 286.059L219.664 445.388L217.938 445.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.717 363.091C114.006 358.698 114.389 354.362 114.881 350.082C110.318 350.817 106.114 351.6 102.349 352.42C102.334 352.538 102.326 352.658 102.337 352.776C102.339 356.481 106.433 359.979 113.717 363.091Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.356 362.554C329.631 359.405 333.705 355.884 333.692 352.181C333.685 351.693 333.618 351.212 333.472 350.736C329.66 350.037 325.499 349.373 321.035 348.754C321.59 353.292 322.034 357.893 322.356 362.554Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.711 532.844L246.443 516.241L246.215 428.336L285.483 444.942L285.711 532.844Z",
    fill: "#D79641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.479 516.242L158.363 516.47L158.129 428.566L246.257 428.336L246.479 516.242Z",
    fill: "#E7B160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.523 532.849L197.474 533.075L158.363 516.473L246.002 516.242L285.523 532.849Z",
    fill: "#A86725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.542 485.923L246.381 475.838L246.371 470.449L285.534 480.54L285.542 485.923Z",
    fill: "#C42211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.77 493.468L185.924 497.443L198.771 474.047L195.148 474.391L182.77 493.468Z",
    fill: "#D79641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.164 475.327L202.209 475.315L202.201 471.328L199.755 471.334L197.164 475.327Z",
    fill: "#CF0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.732 493.365L218.6 497.361L205.633 474.027L209.258 474.351L221.732 493.365Z",
    fill: "#D79641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.251 475.3L202.211 475.317L202.203 471.33L204.639 471.324L207.251 475.3Z",
    fill: "#CF0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.355 470.463L158 470.684L158.013 476.069L246.368 475.848L246.355 470.463Z",
    fill: "#C9281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.94 427.998L199.559 428.012L199.779 516.365L205.161 516.351L204.94 427.998Z",
    fill: "#C9281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.702 471.954L173.906 485.967L184.989 494.164L199.751 471.336L191.702 471.954Z",
    fill: "#C9281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.316 476.195L197.168 475.335L197.667 474.398L191.146 472.348L186.316 476.195Z",
    fill: "#931A0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.162 475.328L171.949 463.57L188.492 451.832L199.753 471.335L197.162 475.328Z",
    fill: "#C9281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.694 471.896L230.543 485.82L219.519 494.074L204.637 471.324L212.694 471.896Z",
    fill: "#C9281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.098 476.12L207.245 475.314L206.742 474.377L213.247 472.293L218.098 476.12Z",
    fill: "#931A0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25 475.301L232.396 463.415L215.8 451.762L204.637 471.325L207.25 475.301Z",
    fill: "#C9281B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10006_2855",
    x: -272.148,
    y: -100,
    width: 975.105,
    height: 1030,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_10006_2855"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientRed);
export default __webpack_public_path__ + "static/media/gradient_red.5587acd10198d8b65caebcee6013020d.svg";
export { ForwardRef as ReactComponent };